import { useQuery } from "react-query";
import { getWarrantyCoverages } from "../../../../actions/CarrierAgreementMgmt/Security";

export const useWarrantyCoverages = () => {
  const { data, isLoading, refetch } = useQuery(
    "GetWarrantyCoverages",
    getWarrantyCoverages,
    {
      refetchOnWindowFocus: false,
    }
  );

  return { data, isLoading, refetch };
};
